import { api } from './api';
import type {
  PartnerConnection, PartnerConnectionCreateRequest, PartnerConnectionUpdateRequest,
  PaginatedResponse, QueryParams, TestConnectionResult,
} from '../types/partners';

export const partnerConnectionsService = {
  getAll: async (params?: QueryParams): Promise<PaginatedResponse<PartnerConnection>> => {
    const res = await api.get<PaginatedResponse<PartnerConnection>>('/api/v1/partner-connections/list', { params });
    return res.data;
  },
  getById: async (id: string): Promise<PartnerConnection> => {
    const res = await api.get<{ data: PartnerConnection }>(`/api/v1/partner-connections/get/${id}`);
    return res.data.data;
  },
  /** `appId`: create it in that project (one the caller can use) rather than the caller's own. */
  create: async (data: PartnerConnectionCreateRequest, appId?: string) =>
    (await api.post('/api/v1/partner-connections/create', data, { params: appId ? { app_id: appId } : undefined })).data,
  update: async (id: string, data: PartnerConnectionUpdateRequest) => (await api.put(`/api/v1/partner-connections/update/${id}`, data)).data,
  delete: async (id: string) => (await api.delete(`/api/v1/partner-connections/delete/${id}`)).data,
  test: async (id: string): Promise<TestConnectionResult> => {
    const res = await api.post<{ data: TestConnectionResult }>(`/api/v1/partner-connections/test/${id}`);
    return res.data.data;
  },
};
